import PropTypes from "prop-types";
import { TbZoomMoney } from "react-icons/tb";

const IncomeIcon = ({ onClick, size, sx, className }) => {
  return (
    <TbZoomMoney
      className={`icon ${className}`}
      size={size}
      onClick={onClick}
      style={sx}
      title="Income"
    />
  );
};

IncomeIcon.defaultProps = {
  size: 30,
  sx: {},
  onClick: () => {},
  className: "",
};

IncomeIcon.propTypes = {
  onClick: PropTypes.func,
  size: PropTypes.number,
  className: PropTypes.string,
  sx: PropTypes.object,
};

export default IncomeIcon;
